import { useEffect, useState } from "react";
import Adjust from "@adjustcom/adjust-web-sdk";

export default function MobileAppDownloadBanner2() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();

    const isMobile = /android|iphone|ipad|ipod/.test(ua);

    // PWA standalone detection
    const isStandalone =
      window.navigator.standalone === true ||
      window.matchMedia("(display-mode: standalone)").matches;

    // Detect Median WebView APK
    const isMedianApp = navigator.userAgent.includes("MedianApp");

    // Show ONLY in mobile browser
    if (isMobile && !isStandalone && !isMedianApp) {
      setVisible(true);
    }
  }, []);


  const close = () => {
    localStorage.setItem("hide_download_banner", "1");
    setVisible(false);
  };

  const handleDownloadClick = () => {
    // 🔥 Adjust APP DOWNLOAD event
    if (window.Adjust) {
      Adjust.trackEvent("9qgdkz"); // app_download
    }
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        background: "#000",
        padding: 16,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 12,
        zIndex: 9999,
      }}
    >
      <button
        onClick={close}
        style={{
          position: "absolute",
          top: 6,
          right: 12,
          fontSize: 14,
          background: "transparent",
          border: "none",
          color: "#fff",
        }}
      >
        ✕
      </button>

      <span style={{ color: "#fff", fontWeight: 600 }}>
        DOWNLOAD MOBILE APP
      </span>

      <div style={{ display: "flex", gap: 12 }}>
        <a
          href="/trubetx.apk"
          onClick={handleDownloadClick}
          style={{
            background: "linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113))",
            borderRadius: 8,
            padding: "12px 28px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: 8,
            textDecoration: "none",
            color: "#000",
            boxShadow: "rgba(35, 238, 136, 0.3) 0px 0px 12px, rgb(159, 232, 113) 0px -2px inset"
          }}
        >
          <img src="https://cdn-icons-png.flaticon.com/512/152/152753.png" width={20} />
          ANDROID
        </a>


      </div>
    </div>
  );
}
